import React from "react"
import { Info } from "lucide-react"

export default function KeyVal({ label, value, muted, link }: { label: string; value: string; muted?: boolean; link?: boolean }) {
  return (
    <div className="grid grid-cols-2 gap-2 items-baseline">
      <div className="flex items-center gap-1 text-xs text-muted-foreground">
        <Info className="h-3 w-3" />
        <span>{label}</span>
      </div>
      <div className={muted ? "text-sm text-muted-foreground" : "text-sm font-medium text-gray-900"}>
        {link ? (
          <a href="#" className="text-blue-700 underline">{value}</a>
        ) : (
          value
        )}
      </div>
    </div>
  )
}

